import { useUserSettings } from '@/state/user-settings/UserSettingsProvider';
import { useUpdateUserSettings } from '@/state/user-settings/useUpdateUserSettings';
import { atom, useRecoilState } from 'recoil';

export const avatarsIsMutatingFavourites = atom<boolean>({
    key: 'avatars-is-mutating-favourites',
    default: false,
});

export const useAddAvatarToFavourites = (avatarId: string) => {
    const [isMutating, setIsMutating] = useRecoilState(avatarsIsMutatingFavourites);
    const { mutateAsync: updateUserSettings, isLoading: updateLoading } = useUpdateUserSettings();
    const { userSettings } = useUserSettings();

    const favouriteAvatars = userSettings?.preferences?.avatars || [];
    const isFavourite = favouriteAvatars.includes(avatarId);

    const handleAddToFavourites = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setIsMutating(true);
        e.stopPropagation();

        const updatedAvatars = [...favouriteAvatars, avatarId];
        await updateUserSettings({ preferences: { avatars: updatedAvatars } });
        setIsMutating(false);
    };

    const handleRemoveFromFavourites = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setIsMutating(true);
        e.stopPropagation();

        const updatedAvatars = favouriteAvatars.filter((v: string) => v !== avatarId);
        await updateUserSettings({ preferences: { avatars: updatedAvatars } });
        setIsMutating(false);
    };

    return {
        isMutating,
        isLoading: updateLoading,
        isFavourite,
        toggle: isFavourite ? handleRemoveFromFavourites : handleAddToFavourites,
    };
};
